import { Button, Empty, Table, message, Modal, Card, Space } from "antd";
import { FileSearchOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import useSWR from "swr";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import moment from "moment";
import 'moment/locale/es' 
import Patient from "./Patient";
import ObservationShow from "./ObservationShow";
import t from "./translate";

moment.locale('es');

function getSearchUrl(patient) {
  return (
    patient &&
    `https://servers.techconnect.cl/HAPI/Observation/?subject=Patient/${patient.id}`
  );
}

function getValue({ valueQuantity }) {
  return valueQuantity.value && `${valueQuantity.value} ${valueQuantity.unit}`;
}

function getName({ code }) {
  const codeValue = get(code, "coding[0].code");
  return get(code, "coding[0].display") || t(codeValue) || codeValue;
}

function getObservations(data) {
  const entry = get(data, "entry", []);
  return orderBy(
    entry.map(({ resource }) => {
      const component = resource.component || [];
      const singleValueObservation = !component.length;

      if (singleValueObservation) {
        component.push({
          code: resource.code,
          valueQuantity: resource.valueQuantity,
        });
      }

      return {
        id: resource.id,
        name: getName(resource),
        date: moment(resource.effectiveDateTime).format("lll"),
        results: component.map(({ code, valueQuantity }, index) => ({
          id: get(code, "coding[0].code", index),
          name: getName({ code }),
          value: getValue({ valueQuantity }),
        })),
      };
    }),
    ["date", "id"],
    "desc"
  );
}

export default function ObservationSearch() {
  const [patient, setPatient] = useState(null);
  const [observation, setObservation] = useState(null);
  const { data } = useSWR(getSearchUrl(patient));
  const observations = getObservations(data);

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Card title="Búsqueda de exámenes">
        <Patient
          onChange={setPatient}
          onError={() => message.warning("No encontramos al paciente")}
        />
      </Card>
      {patient && (
        <Card title="Exámenes del paciente" className="table-wrapper">
          <Table
            locale={{
              emptyText: (
                <Empty
                  description="No tiene exámenes"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ),
            }}
            columns={[
              {
                title: "ID",
                key: "id",
                render: (item) => (
                  <Button
                    type="link"
                    onClick={() => setObservation(item)}
                    icon={<FileSearchOutlined />}
                  >
                    {item.id}
                  </Button>
                ),
              },
              { title: "Examen", dataIndex: "name" },
              { title: "Fecha", dataIndex: "date" },
            ]}
            dataSource={observations}
            rowKey="id"
          />
        </Card>
      )}
      <Modal
        title={`Resultados exámen #${get(observation, "id")}`}
        visible={!!observation}
        onCancel={() => setObservation(null)}
      >
        {observation && <ObservationShow observation={observation} />}
      </Modal>
    </Space>
  );
}
